export default "__VITE_ASSET__9gfCeW7b__"